import { postPlanStatCard } from "api/planAPI";
import {
  PLAN_TYPE,
  PostPlanStatCardResponse,
  StatCardResultDto,
} from "api/interfaces/planInterface.interface";
import { BILLING_CYCLE } from "api/interfaces/subscription.interface";
import { useMemo } from "react";
import { useQuery } from "react-query";

type Args = {
  accountId: string;
  cycle: BILLING_CYCLE;
  type: PLAN_TYPE;
};

function createEmptyStatCard(
  cycle: BILLING_CYCLE,
  type: PLAN_TYPE | undefined
): StatCardResultDto {
  return {
    cycle,
    cycleDays: 30,
    type: type ?? PLAN_TYPE.CHANNEL,
    activeUser: { endUser: 0, inActivate: 0 },
    activeChannels: { channel: 0, channelPrice: 0, sumChannel: 0 },
    activeStorage: { storage: 0, storagePrice: 0, sumStorage: 0 },
    estimateCost: { cost: 0 },
    yearlyCredit: { amount: 0, contract: 0, period: 1 },
    usedCredit: { used: 0, start: "", end: "" },
    leftCredit: { remains: 0, utilization: 0 },
    burnRate: { rate: 0 },
    expireCredit: { expireDate: "", rate: 0, remainDate: 1 },
  };
}

export default function usePlanStatCard({ accountId, cycle, type }: Args) {
  const query = useQuery(
    ["postPlanStatCard", accountId, cycle, type],
    () =>
      postPlanStatCard({
        accountId: accountId!,
        payload: { cycle: cycle!, type },
      }),
    {
      enabled: !!accountId && !!cycle,
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );

  const summary: StatCardResultDto = useMemo(() => {
    const fallback = createEmptyStatCard(cycle ?? BILLING_CYCLE.MONTHLY, type);
    const data = query.data as PostPlanStatCardResponse | undefined;
    if (!data || data.error !== 0) {
      return fallback;
    }
    return data.result ?? fallback;
  }, [query.data, cycle, type]);

  return {
    ...query,
    summary,
  };
}
